import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BatchEntryService } from 'src/service/batch-entry.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, AdditionalServiceType, BusinessEnabledOption, InteractionType, LocalService, PageKey, Status, Wrappers15 } from 'src/service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-batch-entries',
  templateUrl: './batch-entries.component.html',
  styleUrl: './batch-entries.component.scss'
})
export class BatchEntriesComponent {
  BusinessEnabledOption = BusinessEnabledOption; AdditionalServiceType = AdditionalServiceType;
  lstSectionConfigKeys: string[] = ["common", "table", "purchase_entry"];
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0; maxBodyHeight = 0;
  source: Wrappers15; isOpenBatchEntry = false; selectedBatchEntryId: string = '';
  isShowInActive: boolean = false; hasValidBatchDetails = false; isBatchEnabledInBusiness: boolean | null = null;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private batchEntryService: BatchEntryService, private sellerManagementService: SellerManagementService, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.hasValidBatchDetails = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsEnableBatchDetails);
        this.configurationManagementService.ensurePageActions(PageKey.BatchEntries, this.businessId);
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onCheckBusinessEnabledOption();
  }

  onCheckBusinessEnabledOption() {
    this.sellerManagementService.isBusinessOptionEnabled(BusinessEnabledOption.IsEnableBatchDetails, this.businessId).subscribe(result => {
      this.isBatchEnabledInBusiness = result.status == Status.Success;
    });
  }

  isProcessing = false;
  onLoad() {
    if (!this.isProcessing) {
      this.isProcessing = true;
      this.batchEntryService.getBatchEntries(this.businessId, this.source && this.source.paging ? this.source.paging : undefined, !this.isShowInActive).subscribe(result => {
        this.source = result;
        this.isProcessing = false;
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.selectedBatchEntryId = key;
        this.isOpenBatchEntry = true;
      } break;
      case 2: {
        this.router.navigate(['/seller' + this.localService.basicParamsString, this.businessId]);
      } break;
    }
  }

  onActiveInactiveStatus(key: string) {
    this.batchEntryService.activeInactiveStatus(key, ActiveInactiveFor.BatchEntry).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == key);
        if (item) {
          item.v4 = item.v4 == '1' ? '0' : '1';
        }
      }
    });
  }
}
